import React from 'react';

import type { FormatterProps } from './type';
import { toEventTO, type EventTO } from '../../../../../lib';
const RenalFunctionFormatter = ({ row }: FormatterProps) => {
  if (
    !row ||
    !row.last_episode.episodeEvents?.eGFREvents ||
    row.last_episode.episodeEvents?.eGFREvents?.length === 0
  ) {
    return <span>-</span>;
  }

  const events: EventTO[] =
    row.last_episode.episodeEvents.eGFREvents.map(toEventTO);
  const data = events.sort((a, b) => (a.eventDate > b.eventDate ? -1 : 1))[0];
  const nameAndValue = `${data.name === '.Estimated Glomerular Filtration Rate' ? 'eGFR' : data.name} ${data.detail?.fhir?.valueQuantity?.value || ''}`;
  return <span>{nameAndValue}</span>;
};

export default RenalFunctionFormatter;
